export var IndustryExtractor = {
    id: function (item) { return item.id; },
    name: function (item) { return item.name; },
    fullName: function (item) { var _a; return (_a = item.fullName) !== null && _a !== void 0 ? _a : item.name; },
};
